import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';

import { ElementTypeActions } from '../../../actions/elementType';

import WbsLayout from '../../../components/WbsLayout/';
import Loading from '../../../components/Loading';
import NoElements from '../../../components/states/NoElements';
import ElementsByTypeContainer from './ElementsByTypeContainer';

import {
  currentElementTypeSelector,
  currentElementTypeIdSelector,
  taskTypeIdSelector,
  milestoneTypeIdSelector,
  elementTypesSelector,
} from '../../../reducers/elementTypes';
import {
  shouldLoadElementByTypeSelector,
  elementsByTypeSelector,
  filterElementsByType,
  elementsByTypeLoadingSelector,
} from '../../../reducers/elementsByType';
import { elementsSelector } from '../../../reducers/elements';

const ElementsByTypeSelector = immutableCreatorSelector(
  [
    taskTypeIdSelector,
    milestoneTypeIdSelector,
    currentElementTypeIdSelector,
    currentElementTypeSelector,
    elementsSelector,
    shouldLoadElementByTypeSelector,
    elementsByTypeSelector,
    elementTypesSelector,
    elementsByTypeLoadingSelector,
  ],
  (
    taskTypeId,
    milestoneTypeId,
    elementTypeId,
    elementType,
    elements,
    shouldLoadElementByType,
    elementsByType,
    elementTypes,
    elementsByTypeLoading,
  ) => {
    return {
      taskTypeId,
      milestoneTypeId,
      elementTypeId,
      elementType,
      elements,
      shouldLoadElementByType,
      elementsByType,
      elementTypes,
      filteredElements: filterElementsByType(
        elementsByType,
        elementTypeId,
        taskTypeId,
        milestoneTypeId,
      ),
    };
  },
);

@connect(ElementsByTypeSelector)
export default class ElementsByTypeWrapper extends Component {
  static propTypes = {
    taskTypeId: PropTypes.string,
    elementTypeId: PropTypes.string,
    elementType: PropTypes.instanceOf(Map),
    elementTypes: PropTypes.instanceOf(Map),
    filteredElements: PropTypes.instanceOf(List),
    elements: PropTypes.instanceOf(Map),
    shouldLoadElementByType: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    const Wbs = List(); //props.taskTypeId === props.elementTypeId ? props.workBreakdownStructure : List();

    this.state = {
      sortType: Wbs,
      sortBy: 'Alphabetical',
      filterType: null,
      workBreakdownStructure: Wbs,
    };
  }

  componentDidMount() {
    const { elementTypeId, shouldLoadElementByType, taskTypeId } = this.props;

    this.dispatchGetElementsByType(elementTypeId && shouldLoadElementByType && taskTypeId);
  }

  componentDidUpdate() {
    const { filteredElements, shouldLoadElementByType, taskTypeId } = this.props;

    this.dispatchGetElementsByType(
      !filteredElements.size && shouldLoadElementByType && taskTypeId
    );
  }

  setSortBy = sortBy => {
    this.setState({
      sortBy,
    });
  };

  setSortOrFilter = (entity, entityType, add) => {
    const { sortType, workBreakdownStructure } = this.state;

    switch (entityType) {
      case 'sort':
        if (add) {
          if (sortType.indexOf(entity) === -1) {
            this.setState({
              sortType: sortType.push(entity),
            });
          }
        } else {
          if (sortType && sortType.size > 0) {
            this.setState({
              sortType: sortType.pop(),
            });
          }
        }
        break;
      case 'filter':
        this.setState({
          filterType: add ? entity : null,
        });
        break;
      case 'wbs':
        this.setState({
          sortType: workBreakdownStructure,
        });
        break;
      default:
        break;
    }
  };

  dispatchGetElementsByType = check => {
    const { elementTypeId, dispatch, taskTypeId, milestoneTypeId } = this.props;

    // TODO: FIX THIS UNDEFINED CHECK - Problem with routeParams selector
    if (check && elementTypeId !== 'undefined') {
      if (elementTypeId === taskTypeId) {
        dispatch(
          ElementTypeActions.getElementsByType(elementTypeId),
        ).then(() => {
          dispatch(ElementTypeActions.getElementsByType(milestoneTypeId));
        });
      } else {
        dispatch(ElementTypeActions.getElementsByType(elementTypeId));
      }
    }
  };

  render() {
    const { sortType, sortBy, filterType } = this.state;

    const { elementType, elements, shouldLoadElementByType, taskTypeId } = this.props;

    if (shouldLoadElementByType || !elements || !taskTypeId) {
      return <Loading loadingMessage="Elements are being loaded..." />;
    } else if (!elements.size || !elementType) {
      return <NoElements missingEntity="tasks" />;
    }

    return (
      <WbsLayout>
        <ElementsByTypeContainer
          sortType={sortType}
          sortBy={sortBy}
          filterType={filterType}
          setSortByCallback={this.setSortBy}
          setSortOrFilterCallback={this.setSortOrFilter}
          {...this.props}
        />
      </WbsLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ElementsByType/ElementsByTypeWrapper.js